import { value } from "jsonpath";
import { searchFontForDynamicText } from "./thunk";
import config from "../../config";
import { cleanString } from "../helper";

export async function createLinkForDynamicTextFont(creatives = [], filteredFontList, brandId) {
  try {
    const fonts = getFontNamesFromCreativeObj(creatives);
    const fontLinkEls = [];
    let i = 0;
    do {
      if (fonts[i].name && fonts[i].name !== '' && fonts[i].name !== ' ') {
        const foundFont = filteredFontList.find(item => item.family === fonts[i].name);
        if (foundFont) {
          if (foundFont.isGoogleFonts === true) {
            const googleFontLink = createGoogleFontLink(foundFont.family, foundFont.variants);
            fontLinkEls.push(googleFontLink);
          } else if (foundFont.isGoogleFonts === false) {
            const brandFontLink = createBrandFontLink(foundFont.family, foundFont.variants, brandId);
            fontLinkEls.push(brandFontLink);
          }
        }
      }
      i++;
    } while (i < fonts.length);
    return fontLinkEls;
  } catch (error) {
    // console.log(error);
  }
}

export function getFontNamesFromCreativeObj(creatives) {
  try {
    const fonts = [];
    if (creatives.length > 0) {
      let i = 0;
      do {
        const creativeObj = creatives[i].figmaObject;
        const creativeFonts = creativeObj.node.frame.fonts.split('||');
        if (creativeFonts.length > 0) {
          let k = 0;
          do {
            const fontPartials = creativeFonts[k].split(':');
            fonts.push({ name: fontPartials[0], style: fontPartials[1], weight: fontPartials[2] });
            k++;
          } while (k < creativeFonts.length);
        }
        i++;
      } while (i < creatives.length);
    }
    const filteredFonts = fonts.filter((font, index, self) =>
      index === self.findIndex((f) =>
        f.name === font.name && f.weight === font.weight && f.style === font.style
      )
    );
    return filteredFonts;
  } catch (error) {
    // console.log(error);
  }
}

export function getFontNamesFromDynamicText(dynamicText = []) {
  try {
    const fontFamilies = [];
    let i = 0;
    do {
      let l = 0;
      do {
        const text = dynamicText[i].texts[l];
        if (text.type === 'text') {
          if (text.isFeed === false) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(text.value, 'text/html');
            const elements = doc.querySelectorAll('*[style]');
            elements.forEach(item => {
              const style = item.getAttribute('style');
              const fontNameMatch = style.match(/font-family:\s*([^;]+)/);
              const fontWeightMatch = style.match(/font-weight:\s*([^;]+)/);
              const fontStyleMatch = style.match(/font-style:\s*([^;]+)/);
              if (fontNameMatch && fontWeightMatch) {
                fontFamilies.push({
                  name: fontNameMatch[1].replace(/['"]/g, '').trim(),
                  weight: fontWeightMatch[1].replace(/['"]/g, '').trim(),
                  style: (fontStyleMatch ? fontStyleMatch[1].replace(/['"]/g, '').trim() : 'normal')
                });
              }
            });
          } else {
            if (text?.style) {
              const fontNameMatch = text?.style.match(/font-family:\s*([^;]+)/);
              const fontWeightMatch = text?.style.match(/font-weight:\s*([^;]+)/);
              const fontStyleMatch = text?.style.match(/font-style:\s*([^;]+)/);
              if (fontNameMatch && fontWeightMatch) {
                fontFamilies.push({
                  name: fontNameMatch[1].replace(/['"]/g, '').trim(),
                  weight: fontWeightMatch[1].replace(/['"]/g, '').trim(),
                  style: (fontStyleMatch ? fontStyleMatch[1].replace(/['"]/g, '').trim() : 'normal'),
                });
              }
            }
          }
        }
        l++;
      } while (l < dynamicText[i].texts.length);
      i++;
    } while (i < dynamicText.length);
    const fonts = fontFamilies.filter((font, index, self) =>
      index === self.findIndex((f) =>
        f.name === font.name && f.weight === font.weight && f.style === font.style
      )
    );
    return fonts;
  } catch (error) {
    // console.log(error);
    return [];
  }
}

export function createGoogleFontLink(fontFamily, variants) {
  if (variants.length > 0) {

    let normalArray = [];
    let italicArray = []
    let i = 0;
    do {

      let variant = variants[i];
      if (variant.includes("italic")) {
        if (variant == "italic") {
          variant = "400"
        }
        italicArray.push(`1,${variant.replace("italic", "")}`)

      } else {
        if (variant == "regular") {
          variant = "400"
        }
        normalArray.push(`0,${variant}`)
      }

      i++;
    } while (i < variants.length)
    let normalText = normalArray.join(";")
    let italicText = italicArray.join(";")
    let googleQuery = `https://fonts.googleapis.com/css2?family=${fontFamily}:ital,wght@${normalText}&display=swap&key=${config.googleFontKey}`
    if (italicArray.length > 0) {
      googleQuery = `https://fonts.googleapis.com/css2?family=${fontFamily}:ital,wght@${normalText};${italicText}&display=swap&key=${config.googleFontKey}`
    }
    let styleLink;
    if (document.querySelector(`link[href="${googleQuery}"]`)) {
      styleLink = document.querySelector(`link[href="${googleQuery}"]`);
    } else {
      styleLink = document.createElement("link");
      styleLink.href = googleQuery
      styleLink.rel = "stylesheet"
      document.head.append(styleLink)
    }
    return styleLink
  }
}

export function createBrandFontLink(fontFamily, variants, brandId) {
  if (variants.length > 0) {
    let normalArray = [];
    let italicArray = []
    let i = 0;
    do {

      let variant = variants[i];
      if (variant.includes("italic")) {
        if (variant == "italic") {
          variant = "400"
        }
        italicArray.push(`${variant.replace("italic", "")}`)

      } else {
        if (variant == "regular") {
          variant = "400"
        }
        normalArray.push(`${variant}`)
      }

      i++;
    } while (i < variants.length)
    let normalText = normalArray.join(",");
    let italicText = italicArray.join(",");
    let styleLink;
    let adcNormalQuery = `https://fonts.adcropper.com/fonts/css?family=${fontFamily}&brandId=${brandId}`
    if (document.querySelector(`link[href="${adcNormalQuery}"]`)) {
      styleLink = document.querySelector(`link[href="${adcNormalQuery}"]`);
    } else {
      styleLink = document.createElement("link");
      styleLink.href = adcNormalQuery
      styleLink.rel = "stylesheet"
      document.head.append(styleLink)
    }
    return styleLink
  }
}
export function isJsonPath(path) {
  return typeof path === 'string' && (path.includes('[') && path.includes('.') && path.includes(']') && path.includes('$'));
}

export function setConnectedFeedValueBeforePreview(activeDynamicText, feedPreview) {
  const texts = [];
  let i = 0;
  do {
    const text = activeDynamicText.texts[i];
    if (text.isFeed) {
      const foundFeed = feedPreview.find(item => item.path === text.value && item.name === text.feedName);
      if (foundFeed) {
        texts.push({
          name: text.name,
          tag: text.tag,
          type: text.type,
          value: foundFeed.values[0],
          isFeed: text.isFeed,
          feedName: text.feedName,
          style: text.style
        });
      } else {
        texts.push(text);
      }
    } else {
      texts.push(text);
    }
    i++;
  } while (i < activeDynamicText.texts.length);
  return texts;
};

export function sendMessageForPreview(iframe, previewObject, creativeId, fonts) {
  iframe.onload = () => {
    iframe.contentWindow.postMessage({
      action: 'adc-get-preview',
      previewObject: previewObject,
      creativeId: creativeId,
      fonts: fonts
    }, '*');
  }
}

export function calculateCreativesPerPage(creativeHeight) {
  const screenHeight = window.innerHeight;
  let creativesPerColumn = Math.floor(screenHeight / creativeHeight);

  if (creativesPerColumn % 2 !== 0) {
    creativesPerColumn += 1;
  }

  return creativesPerColumn;
}

export function updateCreativeObjectPosterImg(clonedCreative, poster, dynamicTextName) {
  if (clonedCreative && clonedCreative.figmaObject) {
    const elIds = Object.keys(clonedCreative.figmaObject.node);
    let i = 0;
    do {
      const key = elIds[i];
      if (clonedCreative.figmaObject.node[key].hasOwnProperty('name')) {
        if (cleanString(clonedCreative.figmaObject.node[key].name) === cleanString(dynamicTextName)) {
          clonedCreative.figmaObject.node[key].originalImages = {};
          clonedCreative.figmaObject.node[key].originalImages['1x'] = clonedCreative.figmaObject.node[key].bgimages["1x"];
          clonedCreative.figmaObject.node[key].originalImages['2x'] = clonedCreative.figmaObject.node[key].bgimages["2x"];
          clonedCreative.figmaObject.node[key].bgimages["1x"].data = poster;
          clonedCreative.figmaObject.node[key].bgimages["2x"].data = poster;
          break;
        }
      }
      i++;
    } while (i < elIds.length);
    return clonedCreative;
  } else {
    return null;
  }

};

export function updateAllCreativesPoster(creatives, dynamicTexts) {
  if (dynamicTexts && creatives) {
    const updatedCreatives = [];
    let i = 0;
    do {
      let clonedCreative = JSON.parse(JSON.stringify(creatives[i]));
      const foundDynamicText = dynamicTexts.find(dynamicText => dynamicText.isCreative === true && dynamicText.creativeId === clonedCreative._id);
      if (foundDynamicText) {
        const videoTexts = foundDynamicText.texts.filter(item => item.type === 'video');
        if (Array.isArray(videoTexts) && videoTexts.length > 0) {
          let k = 0;
          do {
            const text = videoTexts[k];
            clonedCreative = updateCreativeObjectPosterImg(clonedCreative, text.poster, text.name);
            k++;
          } while (k < videoTexts.length);
          updatedCreatives.push({...clonedCreative, preview: creatives[i]?.preview});
        } else {
          updatedCreatives.push({...clonedCreative, preview: creatives[i]?.preview});
        }
      } else {
        updatedCreatives.push({ ...clonedCreative, preview: creatives[i]?.preview });
      }
      i++;
    } while (i < creatives.length);
    return updatedCreatives;
  } else {
    return creatives;
  }
};

export function filterCreativesByIdArray(creatives, searchIdArray) {
  const foundCreatives = [];
  let i = 0;
  do {
    const id = searchIdArray[i];
    const foundCreative = creatives.find(creative => creative._id === id); 
    if (foundCreative) {
      foundCreatives.push(foundCreative);     
    }
    i++;
  } while (i > searchIdArray.length);
  return foundCreatives;
}